export default {
  elevator: {
    title: 'Лифт',
    value: 'elevator',
  },
  stairs: {
    title: 'Лестница',
    value: 'stairs',
  },
  default: {
    title: 'Лестница',
    value: 'stairs'
  }
}